<template>
  <div
    class="xcai-chat-header w-full flex justify-between items-center pr-5 pl-4"
  >
    <div class="app-prefix">
      <n-button class="nav-back" quaternary circle size="small">
        <template #icon>
          <loto-left />
        </template>
      </n-button>
    </div>
    <div class="chat-title text-center">{{ chatTitle }}</div>
    <div class="nav-actions">
      <loto-icon
        icon="hugeicons:ai-beautify"
        :style="{
          ...promptStyles,
        }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBotStore } from '@/store'
import { computed } from 'vue'

const chatTitle = computed(() => useBotStore().currentHistory.title ?? '')
const baseIconStyles = {
  fontSize: '1.05rem',
  color: '#c2c2c2',
}

const promptStyles = computed(() =>
  useBotStore().usingContext || true
    ? { ...baseIconStyles, color: '#1e90ff' }
    : { ...baseIconStyles },
)
</script>

<style scoped lang="less">
.xcai-chat-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .chat-title {
    flex: 1 1 auto;
  }
}
</style>
